var map = {
	"./add_circle.svg": 538,
	"./adobeIcon.svg": 8335,
	"./attach_file.svg": 4081,
	"./bot.svg": 6505,
	"./calendar.svg": 874,
	"./chat.svg": 5166,
	"./clipboard_icon.svg": 868,
	"./close.svg": 420,
	"./content_copy.svg": 3410,
	"./description.svg": 6747,
	"./download.svg": 9007,
	"./eye.svg": 5564,
	"./filter.svg": 3817,
	"./illustration.svg": 1307,
	"./info_circle.svg": 3608,
	"./link.svg": 7966,
	"./menu.svg": 5674,
	"./message_icon.svg": 4678,
	"./paperplane_icon.svg": 8109,
	"./people_outline.svg": 7628,
	"./person.svg": 340,
	"./powerpointIcon.svg": 3282,
	"./prize.svg": 2393,
	"./remove_circle.svg": 4629,
	"./search.svg": 9262,
	"./settings.svg": 677,
	"./solar_copy.svg": 6975,
	"./synap_logo.svg": 1342,
	"./thumbs_down.svg": 483,
	"./thumbs_up.svg": 1723,
	"./timer.svg": 9700,
	"./wordIcon.svg": 3500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;